import { UAParser } from 'ua-parser-js'

const browser = new UAParser().getBrowser()

class Browser {
  static name = (browser?.name || '')?.toLowerCase()

  /**
   * Returns current browser information
   * @returns {name: string, version: string, os: string}
   */
  static detect() {
    return browser
  }

  /**
   * Check if the current browser is a safari
   * @returns {boolean}
   */
  static isSafari() {
    return Browser.name === 'safari'
  }

  /**
   * Check if the current browser support video camera
   * @returns {boolean}
   */
  static supportVideoCamera() {
    if (Browser.isSafari()) return false

    return true
  }
}

export default Browser